import React from 'react';

import type { FC } from 'react';

export const Calendar: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M16.666 2.4987H15.8327V1.66536C15.8327 1.20703 15.4577 0.832031 14.9993 0.832031C14.541 0.832031 14.166 1.20703 14.166 1.66536V2.4987H5.83268V1.66536C5.83268 1.20703 5.45768 0.832031 4.99935 0.832031C4.54102 0.832031 4.16602 1.20703 4.16602 1.66536V2.4987H3.33268C2.41602 2.4987 1.66602 3.2487 1.66602 4.16536V17.4987C1.66602 18.4154 2.41602 19.1654 3.33268 19.1654H16.666C17.5827 19.1654 18.3327 18.4154 18.3327 17.4987V4.16536C18.3327 3.2487 17.5827 2.4987 16.666 2.4987ZM15.8327 17.4987H4.16602C3.70768 17.4987 3.33268 17.1237 3.33268 16.6654V6.66536H16.666V16.6654C16.666 17.1237 16.291 17.4987 15.8327 17.4987Z" />
    </svg>
  );
};
